/**
 * Line Renderer - Draws annotation lines
 */

export function drawLine(ctx, line, isSelected = false, layerColor = null, scale = 1) {
  const { start, end, lineType = 'solid', color, lineWidth = 1 } = line;
  // Use item color if set, otherwise use layer color, otherwise use default
  const drawColor = color || layerColor || '#00c8ff';

  ctx.save();

  // Set line style
  // Never thinner on screen than at 100%, so lines still show when zoomed out over a site
  const zoomOut = Math.max(1, 1 / scale);
  ctx.strokeStyle = isSelected ? '#00ffaa' : drawColor;
  ctx.lineWidth = (isSelected ? lineWidth + 1 : lineWidth) * zoomOut;
  ctx.lineCap = 'round';

  // Set dash pattern based on line type
  switch (lineType) {
    case 'dashed':
      ctx.setLineDash([10, 5].map(d => d * zoomOut));
      break;
    case 'dotted':
      ctx.setLineDash([2, 4].map(d => d * zoomOut));
      break;
    case 'dashdot':
      ctx.setLineDash([10, 3, 2, 3].map(d => d * zoomOut));
      break;
    case 'center':
      ctx.setLineDash([20, 5, 5, 5].map(d => d * zoomOut));
      break;
    case 'hidden':
      ctx.setLineDash([8, 4].map(d => d * zoomOut));
      break;
    default:
      ctx.setLineDash([]);
  }

  // Draw the line
  ctx.beginPath();
  ctx.moveTo(start.x, start.y);
  ctx.lineTo(end.x, end.y);
  ctx.stroke();

  // Draw selection indicators
  if (isSelected) {
    ctx.setLineDash([]);
    ctx.fillStyle = '#00ffaa';

    // Start point
    ctx.beginPath();
    ctx.arc(start.x, start.y, 5 * zoomOut, 0, Math.PI * 2);
    ctx.fill();

    // End point
    ctx.beginPath();
    ctx.arc(end.x, end.y, 5 * zoomOut, 0, Math.PI * 2);
    ctx.fill();
  }

  ctx.restore();
}
